import React from 'react';
import { useIdentityChallengeContext } from 'Context/IdentityChallengeContext';
import useComponentDidMount from 'Hooks/useComponentDidMount';
import FullScreenDataContainer
  from 'Components/ComponentLibrary/Components/Uncategorized/DataContainer/FullScreenDataContainer';
import ClientAppContainerContent from 'Components/ClientApp/ClientAppContainerContent';
import useUserContext from 'Context/UserContext';

const ClientApp = () => {
  const { userResource } = useUserContext();
  const { viewType, handleClose } = useIdentityChallengeContext();

  // Close DICRS if the member leaves the client app
  useComponentDidMount(null, () => {
    if (viewType) handleClose();
  });

  return (
    <FullScreenDataContainer
      component={ClientAppContainerContent}
      loading={!userResource}
    />
  );
};

export default ClientApp;
